import { combineEpics } from "redux-observable";
import { userPriceGroupsEpic } from "./userPriceGroupsEpic";

export const esmEpic = combineEpics(userPriceGroupsEpic);
